import { SVGProps } from "react";

export function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {... props}
    >
      <path
        d="M11.0625 18.4688C15.2046 18.4688 18.5625 15.1109 18.5625 10.9688C18.5625 6.82661 15.2046 3.46875 11.0625 3.46875C6.92036 3.46875 3.5625 6.82661 3.5625 10.9688C3.5625 15.1109 6.92036 18.4688 11.0625 18.4688Z"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4375 20.3438L16.3594 16.2656"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
